// removed by extract-text-webpack-plugin
module.exports = {"teamMatchupCell":"GameStatsMatchups__teamMatchupCell--2ZpDv","teamlogo":"GameStatsMatchups__teamlogo--1RzDi","wrapper":"GameStatsMatchups__wrapper--LFrjx"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/GameStatsMatchups/GameStatsMatchups.css
// module id = Tpoh
// module chunks = 47